import { DocumentNode, gql } from '@apollo/client'

export const GET_LANGUAGES: DocumentNode = gql`
    query GetLanguages {
        getLanguages {
            id
            name
        }
    }
`
